module.exports = __webpack_public_path__ + "img/food_06.e237a6df.jpg";